import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { EventFormCustomFormType } from "../../events-screen/event-page-models/event-form-custom-form-type";
import { BaseDiscountModel } from "../../discounts/discount-models/BaseDiscountModel";
import {
  DepositData,
  PaperPaymentItemBatch,
} from "../receipt-page-models/PaperPaymentItem";

@Component({
  selector: "receipt-page-submit-receipt-modal-container",
  templateUrl: "./receipt-page-submit-receipt-modal-container.component.html",
  styleUrls: ["./receipt-page-submit-receipt-modal-container.component.scss"],
})
export class ReceiptPageSubmitReceiptModalContainerComponent implements OnInit {
  public static readonly modalOptions: NgbModalOptions = {
    backdropClass: "user-management-form-main-modal-container",
    backdrop: true,
    windowClass: "deposit-receipt-window-class",
  };
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public depositData: DepositData;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef
  ) {}

  @Input("modalDepositInput")
  public set modalDepositDataInput(depositData: DepositData) {
    this.depositData = depositData;
  }

  public ngOnInit(): void {}

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  public modalActionsHandler($event: any) {
    if ($event === "close") {
      this.modalClose(null);
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-submit-receipt-modal-container/receipt-page-submit-receipt-modal-container.component.ts